import React, { useEffect, useState, useRef } from 'react';
import { Alert, AlertTitle, Link, IconButton, Slide, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Close, WarningOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
// import config from 'src/config';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'fixed',
    width: '100%',
    display: 'block',
    zIndex: theme.zIndex.drawer + 1
  },
  alert: {
    borderRadius: 0,
    overflow: 'auto',
    scrollBehavior: 'smooth'
  }
}));

const SystemNotification = ({ setBannerHeight }) => {
  const { value, setValue } = useLocalStorage(
    'password_deprecation_dismissed',
    false
  );
  const classes = useStyles();
  const announcementRef = useRef(0);
  // const {
  //   systemNotification: { show, type /* , message */ }
  // } = config;

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setBannerHeight(0);
    setValue(true);
    setOpen(false);
  };
  const handleResize = () => {
    setBannerHeight(announcementRef.current?.clientHeight || 0);
  };
  useEffect(() => {
    if (open) {
      // set initial
      setBannerHeight(announcementRef.current?.clientHeight || 0);
      window.addEventListener('resize', handleResize);
    } else {
      window.removeEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, [open]);

  useEffect(() => {
    setTimeout(() => {
      if (value === false) {
        setOpen(true);
      }
    }, 1000);
  }, []);
  // if (!show) return null;

  return (
    <Slide direction="down" in={open} className={classes.wrapper}>
      <Box>
        <Alert
          ref={announcementRef}
          severity="warning"
          className={classes.alert}
          icon={<WarningOutlined fontSize="large" />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <Close fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle>
            Important Notice: Password Authentication Deprecation
          </AlertTitle>
          We recommend switching to API Token-based authentication as Zendesk
          has announced the deprecation of password-based access. The{' '}
          <Link
            href="https://support.zendesk.com/hc/en-us/articles/7386291855386-Announcing-the-deprecation-of-password-access-for-APIs"
            target="_blank"
            rel="noreferrer"
          >
            announcement
          </Link>{' '}
          was made on July 1, 2024, and the changes have been in effect since
          July 31, 2024.
          <br /> <br />
          Learn more about how to transition to API Token{' '}
          <Link
            target="_blank"
            href="https://z3n-bootstrapper.zendesk.com/hc/en-us/articles/29372227259412-Deprecation-of-password-access-for-APIs"
            rel="noreferrer"
          >
            here
          </Link>
          .
        </Alert>
      </Box>
    </Slide>
  );
};

/* <Alert
      ref={announcementRef}
      severity={type}
      className={classes.alert}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={handleClose}
        >
          <Close fontSize="inherit" />
        </IconButton>
      }
      sx={{ mb: 2 }}
    >
      {message}
    </Alert> */

SystemNotification.propTypes = {
  setBannerHeight: PropTypes.func
};

export default SystemNotification;
